/* eslint-disable no-loop-func */
/* eslint-disable  */
import { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import BsCheckbox from '../common/form/elements/bs-checkbox';
import { toast } from 'react-toastify';
import { actions } from 'forms/rrf';
import Message from './message';
import ConfirmPopup from '../common/confirm-popup';
import { deleteMessage, deleteMessages, markMessagesAs, replyMessage } from '../../actions/messages';
import MessageDetails from './message-details';
import { largeDevice, lessThanLargeDevice } from '../../utils/client';
import Reply from './reply';
import { MESSAGE_RECEIVED } from '../../data/messageTypes';
import { initialStates } from '../../initialStates';
import { arrayDiff } from '../../utils/commonFunctions';

const createUnreadTooltip = label => <Tooltip id="unreadTooltip" className="tooltip">{label}</Tooltip>;

const createReplyMessage = (from, at, body) => (`
  -------------------------------------------------------
  From: ${from}
  At: ${at}
  
  ${body}
`);

const COLUMNS = 4;

class MessagesList extends Component {
  state = {
    checked: [],
    opened: undefined,
    reply: false,
    delete: {
      show: false
    }
  };
  
  onReadClicked = () => {
    const {dispatch, messages} = this.props;
    const unread = messages.filter(message => !message.attributes.read)
      .map(message => message.id);
    dispatch(markMessagesAs('read', this.state.checked))
      .then(() => {
        const readMessageCountDecrement = arrayDiff(unread, this.state.checked).length;
        dispatch({
          type: 'DECREMENT_UNREAD_MESSAGE_COUNT',
          payLoad: readMessageCountDecrement
        });
        this.setState({
          checked: []
        });
      });
  };

  onUnreadClicked = () => {
    const {dispatch, messages} = this.props;
    const read = messages.filter(message => message.attributes.read)
      .map(message => message.id);
    
    dispatch(markMessagesAs('unread', this.state.checked))
      .then(() => {
        const readMessageCountIncrement = arrayDiff(read, this.state.checked).length;
        dispatch({
          type: 'INCREMENT_UNREAD_MESSAGE_COUNT',
          payLoad: readMessageCountIncrement
        });
        this.setState({
          checked: [],
          opened: []
        });
      });
  };

  onDeleteClicked = () => {
    this.setState({delete: {show: true}});
  };

  toggleReply = (state, message) => {
    if (state !== undefined) {
      this.setState({reply: state});
    } else {
      this.setState({reply: !this.state.reply});
    }
    
    this.setReplyContent(state, message);
  };

  setReplyContent = (state, message) => {
    const {dispatch} = this.props;

    if (message !== undefined && state) {
      const {attributes: {from, 'created-at': at, body}} = message;
      const msgBody = createReplyMessage(from, at, body);
      
      dispatch(actions.load('deep.reply_message.body', msgBody));
    } else {
      dispatch(actions.load('deep.reply_message', initialStates.reply_message));
    }
  };

  onMessageOpened = (id, status, read) => {
    const {dispatch, messageType} = this.props;
    const openedNext = this.state.opened === id ? undefined : id;
    
    if (messageType === MESSAGE_RECEIVED) {
      if (status && !read) {
        dispatch(markMessagesAs('read', [id]));
        
        dispatch({
          type: 'DECREMENT_UNREAD_MESSAGE_COUNT',
          payLoad: 1
        });
      }
    }
    
    this.setState({
      opened: openedNext,
      reply: false,
    });
  };

  onMessageChecked = (id, status) => {
    const {checked: checkedState} = this.state;
    let checked = [...checkedState];
    
    if (status) {
      checked.push(id);
    } else {
      checked = checkedState.filter(item => item !== id);
    }
    
    this.setState({checked});
  };

  onDeleteMessage = (id) => {
    this.setState({
      delete: {
        show: true,
        id
      }
    });
  };

  handleReply = (payLoad, message) => {
    const {dispatch} = this.props;
    dispatch(replyMessage(message.id, {
      ...payLoad,
      outlet_id: message.attributes['outlet-id'],
    }))
      .then(() => {
        toast.success('Message sent');
        
        this.setState({
          open: undefined,
          reply: false
        });
        dispatch(actions.load('deep.reply_message', initialStates.reply_message));
      });
  };

  handleDelete = (result) => {
    const {id} = this.state.delete;
    const {messageType} = this.props;
    
    if (result) {
      if (id) {
        this.props.dispatch(deleteMessage(id, messageType))
          .then(() => this.setState({
            checked: this.state.checked.filter(checked => checked !== id),
            delete: {show: false}
          }));
      } else {
        this.props.dispatch(deleteMessages(this.state.checked, messageType))
          .then(() => this.setState({
            checked: [],
            delete: {show: false}
          }));
      }
    } else {
      this.setState({delete: {show: false}});
    }
  };

  renderRows = () => {
    const {checked, opened, reply} = this.state;
    const {messages, messageType, area} = this.props;
    const rows = [];
    
    let openedRow;
    
    for (let i = 0; i < messages.length; i += COLUMNS) {
      const messageColumns = messages.slice(i, i + COLUMNS)
        .map((message) => {
          const messageChecked = !!checked.find(item => item === message.id);
          const messageOpened = opened === message.id;
          
          const replyComponent = (
            <Reply
              message={message}
              onCancel={this.toggleReply}
              onReply={(data) => this.handleReply(data, message)}
            />
          );
          
          if (messageOpened) {
            openedRow = (
              <MessageDetails
                key={`${i}-${i + COLUMNS}-open`}
                message={message}
                toggleMessage={() => this.onMessageOpened(message.id, !messageOpened, message.attributes.read)}
                toggleReply={this.toggleReply}
                onDelete={this.onDeleteMessage}
                reply={reply && largeDevice}
                replyComponent={replyComponent}
                messageType={messageType}
              />
            );
          }
          
          return (
            <Message
              col={COLUMNS}
              key={`${message.id}-${message.attributes.read}`}
              message={message}
              checked={messageChecked}
              opened={messageOpened}
              onMessageOpened={this.onMessageOpened}
              onMessageChecked={this.onMessageChecked}
              onDelete={this.onDeleteMessage}
              small={lessThanLargeDevice}
              reply={messageOpened && reply && lessThanLargeDevice}
              toggleReply={this.toggleReply}
              replyComponent={replyComponent}
              messageType={messageType}
              area={area}
            />
          );
        });
      
      rows.push(<Row key={`${i}-${i + COLUMNS}`}>{messageColumns}</Row>);
      
      if (openedRow && largeDevice) {
        rows.push(openedRow);
        openedRow = undefined;
      }
    }
    
    return rows;
  };
  
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions.bind(this));
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions.bind(this));
  }
  
  updateDimensions() {
    if (this.state.opened !== undefined) {
      this.setState({opened: undefined});
    }
    
    this.setState({reply: false});
    
  }
  
  render() {
    const {
      showUnread, showRead, onFilterChanged, messageType
    } = this.props;
    
    const { checked, delete: deletable } = this.state;
    
    return (
      <div className={`message-${MESSAGE_RECEIVED}-container`}>
        {messageType === MESSAGE_RECEIVED && (
          <Row className="my-messages-toolbar">
            <Col className="my-messages-toolbar-filters" lg={8}>
              <OverlayTrigger placement="top" overlay={createUnreadTooltip('Show read messages')}>
              <span className="messages-filter">
                <BsCheckbox
                  inline
                  defaultChecked={showUnread}
                  onChange={e => onFilterChanged('showUnread', e.target.checked)}
                >
                  <i className="fa fa-envelope-open"/>
                  <p>Unread messages</p>
                </BsCheckbox>
              </span>
              </OverlayTrigger>
              
              
              <OverlayTrigger placement="top" overlay={createUnreadTooltip('Show unread messages')}>
              <span className="messages-filter">
                <BsCheckbox
                  inline
                  defaultChecked={showRead}
                  onChange={e => onFilterChanged('showRead', e.target.checked)}
                >
                  <i className="fa fa-envelope"/>
                  <p>Read messages</p>
                </BsCheckbox>
              </span>
              </OverlayTrigger>
              <span className="my-messages-toolbar-filters-delete">
                <Button
                  variant="link"
                  onClick={this.onDeleteClicked}
                  disabled={!checked.length}
                >
                  <i className="fa fa-trash"/>
                </Button>
              </span>
            </Col>
            <Col lg={4} className="ta-right">
              <Button
                variant="link"
                onClick={this.onReadClicked}
                disabled={!checked.length}
              >
                Mark as read
              </Button>
              <Button
                variant="link"
                onClick={this.onUnreadClicked}
                disabled={!checked.length}
              >
                Mark as unread
              </Button>
            </Col>
          </Row>
        )}
        <div className="messages-list">
          {this.renderRows()}        
          {deletable.show && (
            <ConfirmPopup header="Delete message?" onClose={this.handleDelete}>
              <p>Are you sure you want to delete the selected message(s)?</p>
            </ConfirmPopup>
          )}
        </div>
      </div>
    );
  }
}

export default connect()(MessagesList);
